// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { CompanylinkedService } from "../../services/companylinked.service";
import { CompanyLinked } from "../../models/companylinked";
import { FolderService } from "../../services/folder.service";
import { ConfigService } from "../../services/config.service";
import { Folder } from "../../models/folder";
import { TermService } from "../../services/saleterm.service";
import { PurchaseTermService } from "../../services/purchaseterms.service";
import { ConditionService } from "../../services/condition.service";
import { CurrencyService } from "../../services/currency.service";
import swal from "sweetalert2";
import { TaxService } from "../../services/tax.service";
import { Methods } from "../../shared/methods";
import { TitleService } from "../../services/title.service";
import { CompanyService } from "src/app/services/company.service";
import { ErasuremethodService } from "../../services/erasuremethod.service";
import { MatStepper } from "@angular/material/stepper";
declare const $: any;

@Component({
  selector: "app-listcompany-cmp",
  templateUrl: "listcompany.component.html",
  styleUrls: ["./listcompany.component.css"],
  providers: [
    UserService,
    CompanylinkedService,
    FolderService,
    TermService,
    ConditionService,
    CurrencyService,
  ],
})
export class ListcompanyComponent implements OnInit {
  @ViewChild(MatStepper) stepper!: MatStepper;

  name: string;
  animal: string;
  //public dataTable: DataTable;
  public privilegio;
  public activos = 1;
  public cargando = false;
  public companiess: string[][];
  public mtds: Methods = new Methods();

  public pacientes: Array<User>;
  public companies: Array<CompanyLinked>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public pageLimit = "10";
  public page = 1;
  public totalItems = 0;
  public totalPaginas = 1;
  public loading;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public company;
  public status_user;

  public optionsButtonSelect;
  public optionSelectMenuTrigger;
  public filtros = [];
  public config: Array<any> = [];
  public staffData: DinamicData = new DinamicData([
    "check",
    "CV Code",
    "Company Name",
    "Alias",
    "Date",
    "City",
    "Phone",
    "Actions",
  ]);
  public bulk: Array<number> = [];

  constructor(
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private titleServices: TitleService,
    private titleService: Title,
    private _router: Router,
    private _folderService: FolderService,
    private _config: ConfigService,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _taxService: TaxService
  ) {
    this.titleService.setTitle("Companies");
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }
  menuTriggerToShow(newValue: string) {
    if (newValue === "Active") {
      this.activos = 0;
    } else {
      this.activos = 1;
    }
    this.bulk = [];
    this.cambiarActivos();
  }

  DeleteMultiple() {
    swal
      .fire({
        title: "",
        text:
          "Do you want to make this company's " +
          (this.activos === 1 ? "inactive" : "active"),
        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then(
        function (result) {
          if (result.value) {
            let json = {
              ids: this.bulk,
              activo: this.activos,
            };
            this._companylinkedService
              .updateMultiple(this.token, json)
              .subscribe(
                (response) => {
                  if (response.status == "success") {
                    this.getAllPacientes();
                    /*         this.mtds.notifySuccess(
              this.activos === 1 ? 'Company status has been changed to inactive' : 'Company status has been changed to active'
            ); */
                    this.showToast(
                      "success",
                      "Company status has been changed to " +
                        (this.activos === 1 ? "Inactive" : "Activate") +
                        " correctly",
                      2000
                    );
                    this.getAllCompany();
                  } else {
                    this.showToast(
                      "error",
                      "Error! Something went wrong",
                      2000
                    );
                  }
                  this.bulk = [];
                },
                (error) => {
                  console.log(<any>error);
                }
              );
          }
        }.bind(this)
      );
  }

  ngOnInit() {
    this.cargando = true;
    //
    this.optionsButtonSelect = [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ];
    this.optionSelectMenuTrigger = "Active";
    //
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this._config.getConfig("companiescomponentTable").subscribe(
        (r) => {
          if (r.data) {
            this.config = JSON.parse(r.data.data);
          } else {
            this.config = this.mtds.colopt(this.staffData.headers, [false]);
          }
          this.getAllPacientes();
          this.getAllCompany();
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.cargando = false;
        }
      );
    }
    this.titleServices.setTitle("Companies");
  }

  boton(e) {
    switch (e.evento) {
      case "delete": {
        this.deleteFolderfirst(e);
        break;
      }
    }
  }
  public newTaxEx = false;
  openTaxExempt() {
    $("#myModalTax").modal("show");
    this.newTaxEx = true;
  }

  public taxNumber;
  public state_id;
  public fileURL;
  public idCompany;
  public companySaved = false;

  closeTax() {
    if (this.companySaved && (!this.detailFile || !this.fileURL)) {
      this.removeTax();
    } else {
      this.state_id = "";
      this.taxNumber = "";
      this.fileURL = "";
      this.taxId = "";
      this.showMultiFiles = false;

      setTimeout(() => {
        this.showMultiFiles = true;
      }, 0);
    }

    $("#myModalTax").modal("hide");
    this._router.navigate(["/pages/company", this.newCompanyId]);
  }
  createTaxExempt() {
    let tax = {
      company_id: 38,
      taxNumber: this.taxNumber,
      fileUrl: this.fileURL,
      state_id: this.state_id,
    };
    this._taxService.newTaxExempt(tax).subscribe(
      (response) => {
        console.log(response, "TAX");
        this.status_user = response.status;
        if (this.status_user !== "success") {
          // this.status_user = 'error';
        } else {
          this.newTaxEx = false;
          this.showToast(
            "success",
            "Tax Exemption has been save correctly ",
            2000
          );
          this.companySaved = true;
          // this.getListTax();
          // this.closeTax();
          // this.showSwal('success-message');
          console.log("folder created");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  public loadingStates = false;
  public loadingStates2 = false;
  public states: any[] = [];
  public countries;
  public country_id;
  getCountries() {
    this._taxService.getCountries().subscribe((r) => {
      console.log("getCountries r =>", r);
      this.countries = r.data;
      for (let country of this.countries) {
        if (country.name === this.newCompanyCountry) {
          this.country_id = country.id;
        }
      }
      this.getStates(this.country_id);
    });
  }

  getStates(id) {
    this.loadingStates = true;
    this.states = [];

    this._taxService.showAll(id).subscribe((r) => {
      this.states = r.data;
      this.loadingStates = false;
    });
  }

  actions(e) {
    // ['/pages/user', item.id]
    // deleteFolderfirst(item.id)
    console.log("action e => ", e);
    switch (e.action) {
      case "Detail":
        this._router.navigate(["/pages/company", e.id]);
        break;
      case "Active":
        this.deleteFolderfirst(e);
        break;
      case "Inactive":
        this.deleteFolderfirst(e);
        break;
      default:
        break;
    }
    console.log(e);
  }

  deleteUser(company) {
    let json;
    json = {
      activo: company.activo,
    };
    this._companylinkedService
      .deleteCompany(this.token, company.id, json)
      .subscribe(
        (response) => {
          if (response.status == "success") {
            this.getAllPacientes();
            alert("Done");
          } else {
            alert("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  showSwal(type) {
    if (type === "success-message") {
      this.showToast("success", "Company Successfully Saved!", 2000);
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    } else if (type === "warning-message-and-cancel") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this imaginary file!",

          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          buttonsStyling: false,
        })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",

              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
          },
          function (dismiss) {
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",

                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: false,
              });
            }
          }
        );
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal
        .fire({
          title: "Auto close alert!",
          text: "I will close in 2 seconds.",
          timer: 2000,
          showConfirmButton: false,
        })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        );
    } else if (type === "input-field") {
      swal
        .fire({
          title: "Input something",
          html:
            '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            "</div>",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          buttonsStyling: false,
        })
        .then(function (result) {
          swal.fire({
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    }
  }
  public newCompanyId;
  public newCompanyCountry;
  openNuevoCompany(): void {
    this.company = new CompanyLinked(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      0,
      "",
      "",
      "",
      "",
      "",
      0,
      0,
      0,
      0
    );
    let dialogRef = this.dialog.open(NuevoCompany, {
      width: "80%",
      data: { user: this.company },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this._companylinkedService.create(this.token, result).subscribe(
        (response) => {
          console.log(response, "RESPPPP");
          this.newCompanyName = response.company.name;
          this.newCompanyId = response.company.id;
          this.newCompanyCountry = response.company.country;
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.getCountries();
            this.showSwal("success-message");
            this.openTaxExempt();
            //this.animal = result;
            this.getAllPacientes();
            this.getAllCompany();
            this.bulk = [];
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }
  public newCompanyName = "";
  public taxId;
  saveTaxAndNext() {
    let tax = {
      company_id: this.newCompanyId,
      taxNumber: this.taxNumber,
      fileUrl: this.fileURL,
      state_id: this.state_id,
    };
    this._taxService.newTaxExempt(tax).subscribe(
      (response) => {
        console.log(response, "TAX");
        this.status_user = response.status;
        if (this.status_user !== "success") {
          // this.status_user = 'error';
        } else {
          this.newTaxEx = false;
          this.stepper.next();
          console.log(response, "resp tax");
          this.taxId = response.data.id;
          // this.showToast(
          //   "success",
          //   "Tax Exemption has been save correctly ",
          //   2000
          // );
          // this.getListTax();
          // this.closeTax();
          // this.showSwal('success-message');
          console.log("folder created");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  public detailFile;
  public editId;
  removeTax() {
    this._taxService.deleteTaxExempt(this.taxId).subscribe(
      (response) => {
        if (response.status === "success") {
          this.getListTax();
          this.state_id = "";
          this.taxNumber = "";
          this.fileURL = "";
          this.idCompany = "";
          this.newTaxEx = false;
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  public showMultiFiles = true;
  saveEditTax(type) {
    let tax = {
      company_id: this.newCompanyId,
      taxNumber: this.taxNumber,
      fileUrl: this.detailFile
        ? this.detailFile
        : encodeURIComponent(
            "https://ha-software.com/backend/" +
              this.fileURL?.folder +
              "/" +
              this.fileURL?.file
          ),
      state_id: this.state_id,
    };
    this._taxService.editTaxExempt(this.taxId, tax).subscribe(
      (response) => {
        this.status_user = response.status;
        if (this.status_user !== "success") {
          // this.status_user = 'error';
        } else {
          console.log("add", type);
          console.log("finish", type);
          if (!this.detailFile || !this.fileURL) {
            this.newTaxEx = false;
            this.showToast(
              "success",
              "Tax Exemption has been save correctly ",
              2000
            );
            if (type == "add") {
              this.stepper.selectedIndex = 0;
              this.state_id = "";
              this.taxNumber = "";
              this.fileURL = "";
              this.taxId = "";
              this.showMultiFiles = false;

              setTimeout(() => {
                this.showMultiFiles = true;
              }, 0);
            } else {
              console.log("this should bemy company", "");
              this._router.navigate(["/pages/company", this.newCompanyId]);
            }
          }
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  detailTax(id, e) {
    const tax = this.listTax.find((element) => {
      return element.id === id;
    });
    this.editId = tax.id;
    this.detailFile = tax.fileUrl;
    this.state_id = tax.state?.id;
    this.taxNumber = tax.taxNumber;
  }

  public arraytax = [];
  public search = false;
  public filtrosTax = [];
  public pageTax = 1;
  public totalItemsTax = 0;
  public totalPaginasTax = 1;
  public paginaActualTax = 1;
  public itemsPorPaginaTax = "10";
  public configTax: Array<any> = [];
  public listTax = [];

  public taxData: DinamicData = new DinamicData([
    "State",
    "Tax Excempt Registration Number",
    "Actions",
  ]);
  getListTax() {
    // "State",
    //   "Tax Excempt Registration Number",
    // "Actions",
    this.filtrosTax = [
      {
        key: "state",
        title: "State",
        value: "",
        type: "contains",
        key_type: "state_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "taxExemptRegistrationNumber",
        title: "Tax Excempt Registration Number",
        value: "",
        type: "contains",
        key_type: "taxExemptRegistrationNumber_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.loading = true;
    this.arraytax = [];
    this._taxService.listTaxExempt(this.newCompanyId).subscribe((response) => {
      if (response.status === "success") {
        this.listTax = response.data;
        this.taxData.rows = [];
        this.paginaActualTax = Number(response.page_actual);
        this.itemsPorPaginaTax = String(response.items_per_page);
        this.totalItemsTax = Number(response.total_items_count);
        this.totalPaginasTax = Number(response.total_pages);

        for (let element of response.data) {
          let actionButtons = [];

          actionButtons = [
            {
              icon: "edit",
              action: "Detail",
              value: element,
            },
            {
              icon: "delete_outline",
              action: "Remove",
              value: element,
            },
            {
              icon: "file_download",
              action: "Download",
              value: element,
            },
          ];

          this.taxData.rows.push([
            new Cell(element.state.name),
            new Cell(element.taxNumber),

            new Cell(actionButtons, { type: "actions" }),
          ]);
        }
      }
      this.loading = false;
    });
  }
  cambiarActivos() {
    if (this.activos === 1) {
      this.activos = 0;
    } else {
      this.activos = 1;
    }
    console.log("test");
    console.log(this.activos);
    this.getAllPacientes();
    this.getAllCompany();
  }

  updateConfig(e) {
    this.config = e;
    console.log(this.config);
    this._config
      .setConfig("companiescomponentTable", this.config)
      .subscribe((r) => {
        console.log(r);
      });
  }

  getAllCompany() {
    this.filtros = [
      null,
      {
        key: "cvcode",
        title: "CV Code",
        value: "",
        type: "contains",
        key_type: "cvcode_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "companyname",
        title: "Company Name",
        value: "",
        type: "contains",
        key_type: "companyname_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "alias",
        title: "Alias",
        value: "",
        type: "contains",
        key_type: "alias_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "date",
        title: "Date",
        value: "",
        type: "contains",
        key_type: "date_type",
        type_options: [
          { value: "equalto", name: "Equal To" },
          { value: "notequalto", name: "Not Equal To" },
          { value: "greaterthan", name: "Greater Than" },
          { value: "lessthan", name: "Less Than" },
        ],
      },
      {
        key: "city",
        title: "City",
        value: "",
        type: "contains",
        key_type: "city_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "phone",
        title: "Phone",
        value: "",
        type: "contains",
        key_type: "phone_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.staffData.rows = [];
    this.cargando = true;
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }
      this._companylinkedService
        .getNewCompanies(
          this.token,
          page,
          this.activos,
          this.filtros,
          this.pageLimit,
          this.filterrigh,
          this.sortStates
        )
        .subscribe(
          (response) => {
            this.mtds.initTable("#datatables");

            if (response.status == "success") {
              this.page = Number(response.page_actual);
              this.totalItems = Number(response.total_items_count);
              this.totalPaginas = Number(response.total_pages);

              for (let element of response.data) {
                let selected_value = false;

                if (this.bulk.includes(element.id.toString()))
                  selected_value = true;
                const date = new Date(element.createdAt);
                const formattedDate = `${
                  date.getMonth() + 1
                }/${date.getDate()}/${date.getFullYear()}`;
                this.staffData.rows.push([
                  new Cell(element.id, {
                    type: "checkbox",
                    selected: selected_value,
                  }),
                  new Cell(element.companyId),
                  new Cell(element.name),
                  new Cell(element.alias),
                  new Cell(formattedDate),
                  new Cell(element.city),
                  new Cell(element.phone),

                  new Cell(
                    [
                      {
                        icon: "remove_red_eye",
                        action: "Detail",
                        color: "info",
                      },
                    ],
                    { type: "actions" }
                  ),
                ]);
              }
              this.cargando = false;
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
            this.cargando = false;
          },
          (error) => {
            this.cargando = false;
            console.log(<any>error);
          }
        );
    });
  }
  public filterrigh = "";
  public sortStates = "";
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if (columnKey === this.filterrigh) {
      if (this.sortStates === "DESC") {
        this.sortStates = "ASC";
      } else {
        this.sortStates = "DESC";
      }
    } else {
      this.sortStates = "ASC";
    }
    this.filterrigh = columnKey;
    this.getAllCompany();
    /*  this.getData(); */
  }
  getData(e = null) {
    this.cargando = true;
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this.GetCompany(e);
    });
  }

  getAllPacientes() {
    this.cargando = true;

    this.filtros = [];

    this.companiess = [];

    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      /*   this.GetCompany(page); */
    });
  }

  GetCompany(page) {
    this.staffData.rows = [];
    this.cargando = true;
    this._companylinkedService
      .getNewCompanies(
        this.token,
        page !== null ? (this.page = page.page) : (this.page = 1),
        this.activos,
        this.filtros,
        page !== null
          ? (this.pageLimit = page.perPage)
          : (this.pageLimit = "10"),
        this.filterrigh,
        this.sortStates
      )
      .subscribe(
        (response) => {
          this.mtds.initTable("#datatables");

          if (response.status == "success") {
            this.page = Number(response.page_actual);
            this.totalItems = Number(response.total_items_count);
            this.totalPaginas = Number(response.total_pages);

            for (let element of response.data) {
              let selected_value = false;

              if (this.bulk.includes(element.id.toString()))
                selected_value = true;
              const date = new Date(element.createdAt);
              const formattedDate = `${
                date.getMonth() + 1
              }/${date.getDate()}/${date.getFullYear()}`;
              this.staffData.rows.push([
                new Cell(element.id, {
                  type: "checkbox",
                  selected: selected_value,
                }),
                new Cell(element.companyId),
                new Cell(element.name),
                new Cell(element.alias),
                new Cell(formattedDate),
                new Cell(element.city),
                new Cell(element.phone),

                new Cell(
                  [{ icon: "remove_red_eye", action: "Detail", color: "info" }],
                  { type: "actions" }
                ),
              ]);
            }
            this.cargando = false;
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.cargando = false;
        },
        (error) => {
          this.cargando = false;
          console.log(<any>error);
        }
      );
  }
  getClass() {
    if (this.showDtButtons) return "tdbtn";
    return "tdbtn2";
  }
  getClassConta() {
    if (this.showDtButtons) return "with-buttons";
    return "with-buttons2";
  }
  showDtButtons: boolean = false;
  onToggleButtons(show: boolean) {
    this.showDtButtons = show;
  }
  deleteFolderfirst(company) {
    console.log(company);

    swal
      .fire({
        title: "",
        text:
          "Do you want to make this company " +
          (this.activos === 1 ? "inactive" : "active"),
        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then(
        function (result) {
          let setActive = 0;

          if (company.action == "Active") setActive = 1;
          else setActive = 0;
          if (result.value) {
            let json;
            json = {
              activo: setActive,
            };
            this._companylinkedService
              .deleteCompany(this.token, company.id, json)
              .subscribe(
                (response) => {
                  if (response.status == "success") {
                    this.getAllPacientes();
                    this.mtds.notifySuccess(
                      this.activos === 1
                        ? "Company status has been changed to inactive"
                        : "Company status has been changed to active"
                    );
                    this.getAllCompany();
                  } else {
                    alert("Error");
                  }
                },
                (error) => {
                  console.log(<any>error);
                }
              );
          }
        }.bind(this)
      );
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
}

declare interface Valid {
  status: string;
  code: number;
  msg: string;
}

@Component({
  selector: "registro-company",
  templateUrl: "registro-company.html",
  styleUrls: [
    "../../customers/nuevo-cliente/nuevo-cliente.component.css",
    "../../pacientepage/paciente.component.scss",
  ],
  providers: [
    UserService,
    CompanylinkedService,
    TermService,
    ConditionService,
    CurrencyService,
  ],
})
export class NuevoCompany {
  @ViewChild(MatStepper) stepper!: MatStepper;

  public identity;
  public token;
  public user: User;
  public company: CompanyLinked;
  public status_user;
  public privilegio;
  public valid: Valid = {
    status: "",
    code: null,
    msg: "",
  };

  public terms: any[] = [];
  public conditions: any[] = [];
  public currencies: any[] = [];
  public countries: any[] = [];
  public rep_id = null;
  public reptoAssagn: Array<any> = [];
  public purchassingTerms: any[] = [];
  public industryTypes;
  public industry;
  public erasureMethods = [];

  constructor(
    public dialogRef: MatDialogRef<NuevoCompany>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _termService: TermService,
    private _purchassingTermsService: PurchaseTermService,
    private _conditionService: ConditionService,
    private _currencyService: CurrencyService,
    private _taxService: TaxService,
    private _router: Router,
    private _companyService: CompanyService,
    private _erasureService: ErasuremethodService
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    console.log(this.identity);
    this.token = this._userService.getToken();
    console.log(data);
    this.getReps();
    this.getTypeIndustry();
    this._erasureService.showAll().subscribe((response) => {
      console.log(response);
      this.erasureMethods = response.data;
    });
    this.data.user.purchasingCreditLimit = 0;
    this.data.user.creditLimit = 0;
    this.data.user.outstandingInvoiceDayLimit = 0;
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
    }

    this.getTerms();
    this.getConditions();
    this.getCurrencies();
    this.getCountries();
    this.getPurchassingTerms();
  }

  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  get isDisabledFirstStep(): boolean {
    return !this.data.user.companyId || !this.data.user.name;
  }
  get completedFirstStep(): boolean {
    return this.data.user.companyId && this.data.user.name;
  }
  get isDisabledSecondStep(): boolean {
    return (
      !this.data.user.address ||
      !this.data.user.country ||
      !this.data.user.colonia ||
      !this.data.user.city ||
      !this.data.user.zipCode ||
      !this.data.user.phone
    );
  }
  get completedSecondStep(): boolean {
    return (
      this.data.user.address &&
      this.data.user.country &&
      this.data.user.colonia &&
      this.data.user.city &&
      this.data.user.zipCode &&
      this.data.user.phone
    );
  }
  get isDisabledThirdStep(): boolean {
    return (
      !this.data.user.conditionId ||
      !this.data.user.currenciesId ||
      !this.data.user.industryType ||
      !this.data.user.purchasingtermsId ||
      !this.data.user.termsId ||
      !this.data.user.passDataErasure1
    );
  }
  get completedThirdStep(): boolean {
    return (
      this.data.user.conditionId ||
      this.data.user.currenciesId ||
      this.data.user.industryType ||
      this.data.user.purchasingtermsId ||
      this.data.user.termsId ||
      this.data.user.passDataErasure1
    );
  }
  getCountries() {
    this._taxService.getCountries().subscribe((r) => {
      console.log("getCountries r =>", r);
      this.countries = r.data;
      let tmp,
        i = 0;
      for (let countrie of this.countries) {
        if (countrie.id === 1) {
          tmp = countrie;
          this.countries.splice(i, 1);
          break;
        }
        i++;
      }

      // this.data.user.country = "UNITED STATES";
      // this.getStates();
      this.countries.unshift(tmp);
    });
  }

  getPurchassingTerms() {
    this._purchassingTermsService
      .getTermsByCompany(this.token, this.identity.companyId)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.purchassingTerms = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  public loadingStates = false;
  public states: any[] = [];
  public mtds: Methods = new Methods();

  getStates(restartState = false) {
    // console.log("se jhace");
    // this.loadingStates = true;
    this.states = [];
    this.data.user.colonia = "";

    // if (restartState) {
    //   this.data.user.colonia = null;
    // }
    let country_id = null;
    for (let country of this.countries) {
      if (country.name === this.data.user.country) {
        country_id = country.id;
      }
    }

    this._taxService.showAll(country_id).subscribe((r) => {
      this.states = r.data;
      this.loadingStates = false;
    });
  }

  formatName(name: string): string {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  getReps() {
    this._companylinkedService.getRepsValues(this.token).subscribe((r) => {
      // console.log(r);
      if (r.status === "success") {
        this.reptoAssagn = r.data;
      }
    });
  }

  changeStep() {
    this.stepper.next();
  }
  getTypeIndustry() {
    this._companyService.showAll().subscribe(
      (r) => {
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.industryTypes = r.data;
          console.log("industry", this.industryTypes);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  getTerms() {
    this._termService
      .getTermsByCompany(this.token, this.identity.companyId)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.terms = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  getConditions() {
    this._conditionService
      .getConditionsByCompany(this.token, this.identity.companyId)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.conditions = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  getCurrencies() {
    this._currencyService
      .getCurrenciesByCompany(this.token, this.identity.companyId)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.currencies = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  validarCompany() {
    console.log(this.data.user.companyId);
    this._companylinkedService
      .validateCompany(this.token, this.data.user.companyId)
      .subscribe((r) => {
        console.log(r);
        this.valid = r;
      });
  }

  onSubmit() {
    console.log("enviamos");
    console.log(this.user);
  }

  onNoClick(): void {}
}
